import { useUIStore } from '@/stores/uiStore'
import type { FontSize } from '@/stores/uiStore'
import { cn } from '@/lib/utils'

const sizes: { label: string; value: FontSize }[] = [
  { label: 'A-', value: 'sm' },
  { label: 'A', value: 'md' },
  { label: 'A+', value: 'lg' },
]

export function FontSizeToggle() {
  const { fontSize, setFontSize } = useUIStore()

  return (
    <div
      className="flex items-center gap-0.5 rounded-lg border border-border p-0.5"
      role="group"
      aria-label="Font size controls"
    >
      {sizes.map((s) => (
        <button
          key={s.value}
          onClick={() => setFontSize(s.value)}
          className={cn(
            'flex h-6 w-6 items-center justify-center rounded text-[11px] font-medium transition-colors',
            fontSize === s.value
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
          )}
          aria-label={`${s.value === 'sm' ? 'Small' : s.value === 'md' ? 'Medium' : 'Large'} font size`}
          title={s.label}
        >
          {s.label}
        </button>
      ))}
    </div>
  )
}
